




























import { Component, Vue } from "vue-property-decorator";
import { ContentService } from "@/service/content.service";
import { SorryPageNotFoundContent } from "@/models/content/sorry-page-not-found";

@Component({
  components: {}
})
export default class SorryPageNotFound extends Vue {
  content: SorryPageNotFoundContent = {} as SorryPageNotFoundContent;
    textDirection = "ltr";

  async mounted(): Promise<void> {
    const contentService = new ContentService(this.$route);
    this.content = await contentService.getSorryPageNotFoundContent();
    this.textDirection = contentService.TextDirection();

  }
}
